var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5579 17.5282C24.6873 16.6921 23.3128 16.6921 22.4422 17.5282L17.8158 21.9712C17.7024 22.0801 17.6262 22.2219 17.5979 22.3765C17.0437 25.4009 17.0028 28.4971 17.4769 31.5351L17.5894 32.2562H20.5659V26.0397C20.5659 25.6251 20.9016 25.2891 21.3159 25.2891H26.6843C27.0985 25.2891 27.4343 25.6251 27.4343 26.0397V32.2562H30.4107L30.5232 31.5351C30.9973 28.4971 30.9564 25.4009 30.4023 22.3765C30.3739 22.2219 30.2977 22.0801 30.1843 21.9712L25.5579 17.5282ZM21.4037 16.445C22.8546 15.0515 25.1455 15.0515 26.5964 16.445L31.2229 20.888C31.5634 21.2151 31.7925 21.6411 31.8777 22.1058C32.4622 25.296 32.5053 28.5621 32.0053 31.7667L31.8245 32.9252C31.7498 33.4042 31.3375 33.7574 30.853 33.7574H26.6843C26.2701 33.7574 25.9343 33.4214 25.9343 33.0068V26.7903H22.0659V33.0068C22.0659 33.4214 21.7301 33.7574 21.3159 33.7574H17.1471C16.6626 33.7574 16.2504 33.4042 16.1756 32.9252L15.9948 31.7667C15.4948 28.5621 15.5379 25.296 16.1225 22.1058C16.2076 21.6411 16.4367 21.2151 16.7773 20.888L21.4037 16.445Z",
    fill: "#5C697B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fba0e366450c5577bc5a0407543f6177.svg";
export { ForwardRef as ReactComponent };